export default __webpack_public_path__ + "static/media/monster.13d4232d.svg";